import { formatLabel, compareId } from "helpers/securities"
import { isFilterValid } from "helpers/filters"

export const compareSecurity = (item1, item2) => {
  if (item1.assetClass === "index") {
    return item1.indexId === item2.indexId
  }
  return compareId(item1, item2)
}

export const convertUnifiedSearchItemToFilterItem = (item) => {
  const { assetClass, country, exchange, ticker, internalId } = item
  const value = formatLabel(item)
  let security = { assetClass, value, label: value }
  if (assetClass === "index") {
    security = { ...security, id: ticker, indexId: ticker }
  } else {
    security = { ...security, ticker, country, mic: exchange, internalId }
  }
  return security
}

export function mapFilterOns(filters, index, filterOn) {
  return filters.map((filter, i) => {
    if (i !== index) return filter
    let operator = null
    if (filterOn?.operators && filterOn.operators?.length > 0) {
      operator = filterOn.operators.find(op => op.value === "in") || filterOn.operators[0]
    }
    return { ...filter, filterOn, operator, values: [] }
  })
}

export function makeFormattedOptions(filterOns) {
  if (!filterOns || !Array.isArray(filterOns)) {
    return []
  }

  return filterOns.flatMap(category => {
    if (!category?.options || !Array.isArray(category.options)) {
      return []
    }

    return category.options.reduce((acc, option) => {
      if (!option) return acc
      return [...acc, {
        ...option,
        id: option.value,
        label: option.label,
        groupId: category.label,
        groupLabel: category.label,
        order: option.order || 0,
      }]
    }, [])
  })
}

export function getValidFilters(filters) {
  return filters.filter(filter => filter.filterOn && isFilterValid(filter))
}

export const EMPTY_FILTER = [{
  filterOn: null,
  operator: null,
  values: [],
}]
